'use client';
import React, { useRef } from 'react';
import { getCdnUrl } from '@/utils/cdn';

import { motion, useInView } from 'framer-motion';

export default function WelcomeSection() {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: '-100px' });

	const variants = {
		hidden: { opacity: 0, y: 50 },
		visible: { opacity: 1, y: 0 },
	};

	return (
		<section
			ref={ref}
			className="mt-2 sm:mt-0 py-8 sm:py-12 md:py-16 lg:py-24 relative px-10 md:px-14 -top-12 sm:top-0"
		>
			<div className="mx-auto w-full max-w-7xl">
				<div className="grid grid-cols-1 md:grid-cols-5 gap-8 lg:gap-16 items-center">
					{/* Texto à esquerda */}
					<div className="flex flex-col space-y-4 md:space-y-6 lg:space-y-8 md:col-span-2 md:mb-32">
						<motion.h2
							variants={variants}
							initial="hidden"
							animate={isInView ? 'visible' : 'hidden'}
							transition={{ type: 'spring', stiffness: 100, damping: 30, delay: 0.2 }}
							className="text-3xl sm:text-4xl lg:text-5xl font-bold text-forbli-green leading-tight w-56 sm:w-full"
						>
							Bem-vindo ao <span className="text-forbli-green">seu novo lar.</span>
						</motion.h2>
						<motion.div
							variants={variants}
							initial="hidden"
							animate={isInView ? 'visible' : 'hidden'}
							transition={{ type: 'spring', stiffness: 100, damping: 30, delay: 0.4 }}
							className="space-y-4 text-lg lg:text-xl text-gray-600 leading-relaxed"
						>
							<p>
								Na Forbli Construtora, acreditamos que a{' '}
								<span className="text-forbli-green font-semibold">felicidade se encontra nos pequenos detalhes:</span>{' '}
								o cheiro de bolo no forno, o som das risadas das crianças, o aconchego de um abraço no sofá.
							</p>
							<p>
								Por isso,{' '}
								<span className="text-forbli-green font-bold">construímos mais do que apartamentos</span>, criamos lares onde a alegria floresce e os sonhos se tornam realidade.
							</p>
						</motion.div>
						{/* Imagem decorativa abaixo do texto, levemente deslocada para a esquerda */}
						<div className="-top-6 relative sm:pt-8 -ml-8 sm:-ml-16 md:-ml-20 order-first md:order-last md:hidden">
							<img src={getCdnUrl("/images/common/decor-ativo-2.webp")} alt="Decorativo" width={288} height={144} className="w-48 md:w-72" />
						</div>
					</div>

					{/* Imagem à direita - somente a imagem, sem bg branco nem sombra */}
					<div className="relative md:col-span-3">
						<div className="aspect-square relative overflow-hidden rounded-2xl">
							<img
								src={getCdnUrl("/images/common/home-family.webp")}
								alt="Família feliz reunida no sofá"
								className="w-full h-full object-cover sm:pb-40"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
